// Client-side pre-check only, exactly as courtesy validation — the backend re-validates
// authoritatively (size, extension, AND magic-byte signature) regardless of what passes here.
export const ACCEPTED_WIRE_DOCUMENT_EXTENSIONS = ['.pdf', '.png', '.jpg', '.jpeg'];
export const ACCEPTED_WIRE_DOCUMENT_ACCEPT = ACCEPTED_WIRE_DOCUMENT_EXTENSIONS.join(',');
export const MAX_WIRE_DOCUMENT_SIZE_BYTES = 5 * 1024 * 1024; // 5MB

// Returns an error message string, or null when the file passes the courtesy check.
export const validateWireDocumentFile = (file) => {
  if (!file) return 'A file is required.';

  const name = file.name ?? '';
  const dotIndex = name.lastIndexOf('.');
  const ext = dotIndex >= 0 ? name.slice(dotIndex).toLowerCase() : '';

  if (!ACCEPTED_WIRE_DOCUMENT_EXTENSIONS.includes(ext)) {
    return 'Only PDF, PNG, and JPEG files are supported.';
  }
  if (file.size > MAX_WIRE_DOCUMENT_SIZE_BYTES) {
    return 'File exceeds the 5MB limit.';
  }
  return null;
};
